import { useTranslation } from "react-i18next";

import WidgetsGrid from "@/components/Elements/WidgetsGrid";
import BaseHeader from "@/components/Header/BaseHeader";
import { ASSETS_STATISTICS_WIDGETS } from "@/components/ListStatistics/Assets";
import AssetsTable from "@/components/ListTable/AssetsTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { ASSETS_METADATA } from "@/entities/assets";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";
import AssetAddButton from "@/modules/asset/asset-add-button";
import { ListProvider } from "@/modules/list";

const Assets = () => {
  const { t } = useTranslation();

  return (
    <>
      <BaseHeader title={t("navigation:assets")} />
      <AppLayoutPage>
        <ListProvider
          endpoint="assets"
          storageKey={STORAGE_KEYS.ASSETS}
          withMetadata={[ASSETS_METADATA.STATISTICS]}
          withContext
        >
          <WidgetsGrid
            widgets={[
              ASSETS_STATISTICS_WIDGETS.condition_rating,
              ASSETS_STATISTICS_WIDGETS.risk_level,
              ASSETS_STATISTICS_WIDGETS.state,
            ]}
          >
            <AssetsTable
              showAncestorsColumns
              extraActions={<AssetAddButton />}
            />
          </WidgetsGrid>
        </ListProvider>
      </AppLayoutPage>
    </>
  );
};

export default Assets;
